var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.5H3L2.99775 7.1795L11.5732 13.1165C11.6986 13.2033 11.8475 13.2497 12 13.2497C12.1525 13.2497 12.3014 13.2033 12.4268 13.1165L21 7.1825V14H22.5V6.5C22.4994 6.10236 22.3412 5.72117 22.06 5.44C21.7788 5.15882 21.3976 5.0006 21 5H3C2.6023 5.0004 2.221 5.15856 1.93978 5.43978C1.65856 5.721 1.5004 6.1023 1.5 6.5V18.5C1.5006 18.8976 1.65882 19.2788 1.94 19.56C2.22117 19.8412 2.60236 19.9994 3 20H14.25V18.5ZM19.3493 6.5L12 11.588L4.65075 6.5H19.3493Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.5C21.1569 21.5 22.5 20.1569 22.5 18.5C22.5 16.8431 21.1569 15.5 19.5 15.5C17.8431 15.5 16.5 16.8431 16.5 18.5C16.5 20.1569 17.8431 21.5 19.5 21.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.99aed4bee2536d3ec9022d59dc65b0d8.svg";
export { ForwardRef as ReactComponent };